module.exports = __webpack_public_path__ + "img/linked-in-logo-ffffff.fc3ced46.svg";